import { VHeaders } from '@/models/pagedlistmodel';

export function getChargeCustomerHeaders(vm: any): VHeaders[] {
  return [
    {
      text: vm.$parent.$t(
        'customerChargeDetails.headers.accountNumber'
      ) as string,
      align: 'left',
      value: 'accountNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t(
        'customerChargeDetails.headers.controlNumber'
      ) as string,
      align: 'left',
      value: 'controlNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t('customerChargeDetails.headers.postStatus') as string,
      align: 'left',
      value: 'chargeDetailJson.postStatus',
      sortable: false,
    },
    {
      text: vm.$parent.$t('customerChargeDetails.headers.aRDate') as string,
      align: 'left',
      value: 'chargeDetailJson.arStatementDate',
      fieldType: 'date',
      sortable: false,
      format: 'L',
    },
    {
      text: vm.$parent.$t('customerChargeDetails.headers.transDate') as string,
      align: 'left',
      value: 'transactionDate',
      fieldType: 'date',
      format: 'L',
    },
    {
      text: vm.$parent.$t(
        'customerChargeDetails.headers.transNumber'
      ) as string,
      align: 'left',
      value: 'transNumber',
    },
    {
      text: vm.$parent.$t('customerChargeDetails.headers.docNumber') as string,
      align: 'left',
      value: 'chargeDetailJson.documentNumber',
      sortable: false,
    },
    {
      text: vm.$parent.$t('customerChargeDetails.headers.Amount') as string,
      align: 'left',
      value: 'chargeDetailJson.transactionAmount',
      sortable: false,
    },
  ];
}
